import { render, staticRenderFns } from "./SideDateFilter.vue?vue&type=template&id=2ff73832&scoped=true&"
import script from "./SideDateFilter.vue?vue&type=script&lang=js&"
export * from "./SideDateFilter.vue?vue&type=script&lang=js&"
import style0 from "./SideDateFilter.vue?vue&type=style&index=0&id=2ff73832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff73832",
  null
  
)

export default component.exports